import Session from "components/LM/Auth/Session";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import BssoPermissions from "components/LM/Bsso/Permissions";
import NewVoice from "components/LM/Voice/NewVoice";
import Voice from "components/LM/Voice/Voice";
import Loader from "components/Loader";
import K2Api from "lib/ajax/K2Api";

import { ToastService } from "@launchmetrics/lm-ui";

function View() {
	return (
		<BssoPermissions permissions={['voices']} behaviour="error">
			<VoiceLoader />
		</BssoPermissions>
	)
}

function VoiceLoader() {
	const { id } = useParams();
	const [loading, setLoading] = useState(true);
	const [voice, setVoice] = useState();
	const [error, setError] = useState();

	const session = new Session();

	const cancelRef = useRef(false);

    const fetchVoice = async () => {
        const k2 = new K2Api();

        try {
            const voiceData = await k2.get(`/voices/${id}`).catch(() => {
                ToastService.show({
                    id: "fetch-voice-failed",
                    title: "Failed to fetch voice data",
                    type: "error",
                });
                throw new Error("Failed to fetch voice data");
            });
            let mergeSuggestions;

            if (session.hasPermission('edit')) {
                const mergeSuggestionResponse = await k2.get(`/voices/${id}/merge/suggestions`).catch(
                    () => {
                        ToastService.show({
                            id: "fetch-merge-suggestions-failed",
                            title: "Failed to fetch merge suggestions",
                            type: "error",
                        });
                        return { data: null };
                    }
                );
                mergeSuggestions = mergeSuggestionResponse.data;
            }

            const crawlingData = await k2.get(`voices/${id}/crawling`).catch(() => {
                ToastService.show({
                    id: "fetch-voice-crawling-failed",
                    title: "Failed to fetch voice crawling",
                    type: "error",
                });
                return { data: null };
            });

            if (cancelRef.current) return;
            setVoice({ info: voiceData.data, merge_suggestions: mergeSuggestions, crawling: crawlingData.data });
        } catch (error) {
            if (cancelRef.current) return;
            setError(error);
        } finally {
            if (!cancelRef.current) {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (!id) {
            setLoading(false);
        } else {
            cancelRef.current = false;
            fetchVoice();
            return () => { cancelRef.current = true; };
        }
        // eslint-disable-next-line
    }, [id]);

    if (loading) {
		return (<Loader />)
	} else if (!voice) {
        return <NewVoice />
    } else if (voice) {
		return (
			<Voice voice={voice.info} mergeSuggestions={voice.merge_suggestions} crawling={voice.crawling} fetchVoice={fetchVoice}/>
		)
	} else {
		return (
			<div>
				<h1>Error</h1>
				<p>{error.message}</p>
			</div>
		)
	}
}

export default View;
